module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min-400x263.191d3df4.jpg";